exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root{--dur:20s}.header_container{display:flex;justify-content:right}.app_name{color:rgba(0,20,30,.6)!important;display:flex;text-shadow:2px 2px 1px rgba(0,0,0,.3);position:absolute;right:20px;margin-top:-50px;letter-spacing:1px}.fk-systemicon{font-weight:700;margin:.2rem 5px .9rem 20px;font-size:2rem;opacity:.7;color:#fff}.fk-systemtext{font-size:22px!important;margin-top:10px!important}.phat{font-weight:900}.thin{font-weight:400;color:#fff;opacity:.7}.sirener{position:absolute;top:0;right:20px}.top_image{height:130px;opacity:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-437f3680","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Header.vue
// module id = 306
// module chunks = 0